import {FC, useMemo} from "react";
import {AboutItemPageProps} from "../../types";
import * as BUCKETS from "../../../../enums/buckets"
import "./style.less"
import {getImageLink} from "../../../../helpers/mainHelpers";
import TextReader from "../../../../components/text-reader/TextReader";
import Gallery from "../../../../components/galerry/Gallery";
import {Empty, Image, Spin} from "antd";
import {CalendarOutlined, PictureOutlined} from "@ant-design/icons";
import dayjs from "dayjs";

const AboutItemPageBody: FC<AboutItemPageProps> = (props) => {
  const {selectedAboutItem, isLoading} = props.aboutController

  const galleryImages = useMemo(() => {
    if (selectedAboutItem?.images?.length) {
      return selectedAboutItem.images
        .filter((image) => image !== selectedAboutItem.mainImage)
        .map((image) => {
          return getImageLink({bucketId: BUCKETS.MAIN, imageId: image})
        })
    }
    return []
  }, [selectedAboutItem])


  if (isLoading) {
    return <div className="about-article__loading"><Spin spinning size="large"/></div>
  }

  if (!selectedAboutItem) {
    return <div className="about-article__empty"><Empty description="Матеріал не знайдено"/></div>
  }

  const publicationDate = selectedAboutItem.created || selectedAboutItem.$createdAt

  return <article className="about-article">
    <header className="about-article__header">
      <div className="about-article__eyebrow">Інформація про заклад</div>
      <h1 className="about-article__title">{selectedAboutItem.title}</h1>
      {publicationDate && <time className="about-article__date" dateTime={publicationDate}>
        <CalendarOutlined/> {dayjs(publicationDate).format("D MMMM YYYY")}
      </time>}
    </header>

    {selectedAboutItem.mainImage && <div className="about-article__hero">
      <Image
        className="about-article__hero-image"
        preview={false}
        src={getImageLink({bucketId: BUCKETS.MAIN, imageId: selectedAboutItem.mainImage})}
        alt={selectedAboutItem.title}
      />
    </div>}

    <div className="about-article__body">
      <TextReader value={selectedAboutItem.body}/>
    </div>

    {galleryImages.length > 0 && <section className="about-article__gallery">
      <h2 className="about-article__section-title"><PictureOutlined/> Фотогалерея</h2>
      <Gallery images={galleryImages}/>
    </section>}
  </article>

}

export default AboutItemPageBody
